import type { ComponentProps } from 'react';

type RtlUpLogoProps = ComponentProps<'svg'> & {
  readonly colors?: [string, string, string, string];
};

const RtlUpLogo = ({ colors, ...props }: RtlUpLogoProps) => {
  return (
    <svg viewBox="0 0 72 24" focusable="false" role="img" {...props}>
      <title>RTL Up</title>
      <path fill={colors?.[0] ?? '#00af2c'} d="M71.709 0H49.298v12.603h22.41z" />
      <path fill={colors?.[0] === '#ffffff' ? '#000' : '#fff'} d="M56.263 2.897h1.556v5.466h6.925v1.342h-8.481z" />
      <path fill={colors?.[1] ?? '#6e0ced'} d="M47.06 0H24.65v12.603h22.41z" />
      <path
        fill={colors?.[1] === '#ffffff' ? '#000' : '#fff'}
        d="M35.076 4.239h-3.939V2.897h9.435v1.342h-3.939v5.468h-1.557z"
      />
      <path fill={colors?.[2] ?? '#ec33ec'} d="M22.41 0H0v12.603h22.41z" />
      <path
        fill={colors?.[2] === '#ffffff' ? '#000' : '#fff'}
        d="M6.365 2.897h5.972c1.819 0 2.83.817 2.83 2.188 0 1.176-.759 1.965-2.052 2.15l2.928 2.472h-2.246l-2.753-2.385H7.923v2.383H6.367V2.897zm5.768 3.15c.963 0 1.43-.31 1.43-.943s-.467-.935-1.43-.935h-4.21v1.877z"
      />
      <path
        fill={colors?.[3] ?? '#050508'}
        d="M30.697 23.671a2.38 2.38 0 0 1-1.026-.949q-.36-.616-.36-1.453v-4.18h1.244v4.14q0 .818.438 1.24.437.423 1.274.423.836 0 1.28-.422.442-.424.442-1.24v-4.141h1.235v4.18q0 .847-.354 1.463a2.32 2.32 0 0 1-1.021.942q-.667.326-1.58.326-.907.001-1.572-.329M36.934 23.894v-6.805h3.15q.69 0 1.215.277t.811.777q.286.5.286 1.153 0 .662-.286 1.172-.287.51-.81.792-.526.281-1.217.281h-1.905v2.353zm2.985-3.442q.593 0 .904-.297t.312-.86q0-.535-.317-.827-.315-.292-.9-.291h-1.74v2.275z"
      />
    </svg>
  );
};

export default RtlUpLogo;
